import { useEffect, useState } from "react";
import HubUsageSelectionFilterDialog from "./HubUsageSelectionFilterDialog";

export default function HubUsageGroupFilterDialog(props) {
    const [selectedKeys, setSelectedKeys] = useState([]);

    useEffect(() => {
        if (props.open) {
            setSelectedKeys(props.groups.map((group) => group.key));
        }
    }, [props.groups, props.open]);

    function handleToggle(key) {
        setSelectedKeys(
            selectedKeys.includes(key)
                ? selectedKeys.filter((selectedKey) => selectedKey !== key)
                : [...selectedKeys, key],
        );
    }

    return (
        <HubUsageSelectionFilterDialog
            open={props.open}
            onClose={() => props.onClose(selectedKeys)}
            title="Group filter"
            items={props.groups.map((group) => ({
                key: group.key,
                label: group.name,
            }))}
            selectedKeys={selectedKeys}
            onToggle={handleToggle}
            onToggleAll={() =>
                setSelectedKeys(
                    selectedKeys.length === props.groups.length
                        ? []
                        : props.groups.map((group) => group.key),
                )
            }
        />
    );
}
